(function() {
  const init = window.storesMapInit;
  if (!init) return;

  const sectionId = init.sectionId;
  const mapId = 'map-' + sectionId;
  const countryDropdownBtn = document.getElementById('countryDropdownBtn-' + sectionId);
  const countryDropdownMenu = document.getElementById('countryDropdownMenu-' + sectionId);
  const countryDropdownIcon = document.getElementById('countryDropdownIcon-' + sectionId);
  const countryName = document.getElementById('countryName-' + sectionId);
  const countryFlag = document.getElementById('countryFlag-' + sectionId);
  const aroundMeButton = document.getElementById('aroundMeBtn-' + sectionId);
  const searchInput = document.getElementById('searchInput-' + sectionId);

  // Initialize Map - use first location coordinates if available, otherwise use default
  // Initialize map centered on France
  const map = L.map(mapId).setView([46.603354, 1.888334], init.mapZoom);

  // Add OpenStreetMap tiles
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  }).addTo(map);

  // Store all location markers with their data
  const locationMarkers = [];
  let storeLocations = [];
  let allStores = [];

  // Function to calculate distance between two coordinates (Haversine formula)
  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in kilometers
  }

  // Function to add marker and store its data
  function addLocationMarker(location, lat, lng) {
    // Create popup content with store details
    let popupContent = `<div style="min-width: 200px;">
      <strong style="font-size: 14px; color: #1A1A1A;">${location.name}</strong>`;

    if (location.address1) {
      popupContent += `<br><span style="font-size: 13px; color: #6A7282;">${location.address1}</span>`;
    }
    if (location.address2) {
      popupContent += `<br><span style="font-size: 13px; color: #6A7282;">${location.address2}</span>`;
    }
    if (location.postalCode || location.city) {
      popupContent += `<br><span style="font-size: 13px; color: #6A7282;">${location.postalCode} ${location.city}</span>`;
    }
    if (location.phone) {
      popupContent += `<br><a href="tel:${location.phone}" style="font-size: 13px; color: #00664F; text-decoration: none;">📞 ${location.phone}</a>`;
    }
    popupContent += `</div>`;

    const marker = L.marker([lat, lng])
      .addTo(map)
      .bindPopup(popupContent);

    // Store marker with location data
    locationMarkers.push({
      marker: marker,
      name: location.name,
      address: location.address1,
      city: location.city,
      postalCode: location.postalCode,
      lat: lat,
      lng: lng,
      location: location
    });

    return marker;
  }

  // Load stores from stores.json file
  fetch(init.storesJsonUrl)
    .then(response => response.json())
    .then(stores => {
      console.log('Loaded', stores.length, 'stores from stores.json');
      allStores = stores;

      const allowedCountries = ['FRANCE', 'BELGIQUE'];

      // Filter stores with valid coordinates
      storeLocations = stores
        .filter(store => store.latitude && store.longitude && store.latitude !== 0 && store.longitude !== 0)
        .filter(store => allowedCountries.includes((store.lib_pays || '').toUpperCase()))
        .map(store => ({
          name: store.lib_entite || store.lib_entite_court || 'Store',
          address1: store.adresse_1 || '',
          address2: store.adresse_2 || '',
          city: store.ville || '',
          postalCode: store.code_postal || '',
          phone: store.telephone || '',
          country: store.lib_pays || '',
          lat: parseFloat(store.latitude),
          lng: parseFloat(store.longitude),
          hasCoords: true
        }));

      console.log('Displaying', storeLocations.length, 'stores with valid coordinates');

      // Add all store markers to the map
      storeLocations.forEach(store => {
        addLocationMarker(store, store.lat, store.lng);
      });

      // Fit map to show only France stores initially
      const franceStores = storeLocations.filter(s => s.country && s.country.toLowerCase().includes('france'));
      if (franceStores.length > 0) {
        const bounds = L.latLngBounds(franceStores.map(s => [s.lat, s.lng]));
        map.fitBounds(bounds, { padding: [50, 50], maxZoom: 8 });
      } else if (storeLocations.length > 0) {
        // Fallback: show all stores if no France stores found
        const bounds = L.latLngBounds(storeLocations.map(s => [s.lat, s.lng]));
        map.fitBounds(bounds, { padding: [50, 50], maxZoom: 8 });
      }

      // Populate country dropdown
      const countries = [...new Set(storeLocations.map(s => s.country))].filter(c => c).sort();
      const dropdownContent = document.getElementById('countryDropdownContent-' + sectionId);

      if (dropdownContent && countries.length > 0) {
        let html = `
          <div class="stores-map__country-option" data-country="">
            <span class="stores-map__country-option-label">Tous les pays</span>
          </div>
        `;

        countries.forEach(country => {
          html += `
            <div class="stores-map__country-option" data-country="${country}">
              <span class="stores-map__country-option-label">${country}</span>
            </div>
          `;
        });

        dropdownContent.innerHTML = html;
        console.log('Populated country dropdown with', countries.length, 'countries');
      }

      // List card → map: center map on selected store and open its popup
      window.addEventListener('storeSelectFromList', function(event) {
        const { lat, lng } = event.detail;
        map.setView([lat, lng], 14);
        const markerData = locationMarkers.find(m => m.lat === lat && m.lng === lng);
        if (markerData) {
          markerData.marker.openPopup();
        }
      });

      console.log('Map ready — bidirectional sync active');
    })
    .catch(error => {
      console.error('Error loading stores.json:', error);
    });

  // Country Dropdown Toggle
  if (countryDropdownBtn && countryDropdownMenu) {
    countryDropdownBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      const isOpen = !countryDropdownMenu.classList.contains("hidden");

      if (isOpen) {
        countryDropdownMenu.classList.add("hidden");
        countryDropdownIcon.style.transform = "rotate(0deg)";
      } else {
        countryDropdownMenu.classList.remove("hidden");
        countryDropdownIcon.style.transform = "rotate(180deg)";
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (
        !countryDropdownBtn.contains(e.target) &&
        !countryDropdownMenu.contains(e.target)
      ) {
        countryDropdownMenu.classList.add("hidden");
        countryDropdownIcon.style.transform = "rotate(0deg)";
      }
    });

    // Handle country selection with event delegation
    countryDropdownMenu.addEventListener("click", function (e) {
      const option = e.target.closest('.stores-map__country-option');
      if (!option) return;

      e.stopPropagation();

      const selectedCountry = option.getAttribute("data-country");

      // Update dropdown display
      if (selectedCountry) {
        countryName.textContent = selectedCountry;
      } else {
        countryName.textContent = "Tous les pays";
      }

      countryDropdownMenu.classList.add("hidden");
      countryDropdownIcon.style.transform = "rotate(0deg)";

      // Filter stores by selected country
      let filteredStores;
      if (selectedCountry) {
        filteredStores = storeLocations.filter(store =>
          store.country && store.country === selectedCountry
        );
        console.log('Filtering by country:', selectedCountry, '-', filteredStores.length, 'stores');
      } else {
        // Show all stores
        filteredStores = storeLocations;
        console.log('Showing all', filteredStores.length, 'stores');
      }

      if (filteredStores.length > 0) {
        // Fit map to filtered stores
        const bounds = L.latLngBounds(filteredStores.map(s => [s.lat, s.lng]));
        map.fitBounds(bounds, { padding: [50, 50], maxZoom: 10 });

        // Notify directory to filter stores
        window.dispatchEvent(new CustomEvent('storeFilterChange', {
          detail: { filteredStores: filteredStores }
        }));
      } else {
        // No stores found
        console.warn('No stores found for country:', selectedCountry);
      }
    });
  }

  // Search functionality - Search stores by city or postal code
  let searchTimeout;
  let highlightedMarkers = []; // Store highlighted search results
  let searchMarker = null;

  function searchAndMarkLocation(searchQuery) {
    if (!searchQuery || searchQuery.trim() === '') {
      // Clear highlights and reset map view if search is cleared
      highlightedMarkers.forEach(m => {
        if (map.hasLayer(m.marker)) {
          m.marker.setIcon(new L.Icon.Default());
        }
      });
      highlightedMarkers = [];

      // Reset map to show all stores
      if (storeLocations.length > 0) {
        const bounds = L.latLngBounds(storeLocations.map(s => [s.lat, s.lng]));
        map.fitBounds(bounds, { padding: [50, 50], maxZoom: 12 });
      }

      // Notify directory to show all stores
      console.log('Search cleared - showing all', storeLocations.length, 'stores');
      window.dispatchEvent(new CustomEvent('storeFilterChange', {
        detail: { filteredStores: storeLocations }
      }));
      return;
    }

    const query = searchQuery.trim().toLowerCase();

    // Search through stores by city or postal code
    const matchingStores = storeLocations.filter(store => {
      return (store.city && store.city.toLowerCase().includes(query)) ||
             (store.postalCode && store.postalCode.includes(query)) ||
             (store.name && store.name.toLowerCase().includes(query));
    });

    // Clear previous highlights
    highlightedMarkers.forEach(m => {
      if (map.hasLayer(m.marker)) {
        m.marker.setIcon(new L.Icon.Default());
      }
    });
    highlightedMarkers = [];

    if (matchingStores.length > 0) {
      console.log('Found', matchingStores.length, 'matching stores');

      // Highlight matching stores with a different color
      matchingStores.forEach(store => {
        const markerData = locationMarkers.find(m => m.lat === store.lat && m.lng === store.lng);
        if (markerData) {
          const greenIcon = new L.Icon({
            iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
          });
          markerData.marker.setIcon(greenIcon);
          highlightedMarkers.push(markerData);
        }
      });

      // Fit map to show matching stores
      const bounds = L.latLngBounds(matchingStores.map(s => [s.lat, s.lng]));
      map.fitBounds(bounds, { padding: [80, 80], maxZoom: 13 });

      // Notify directory to filter stores
      console.log('Dispatching storeFilterChange event with', matchingStores.length, 'stores');
      window.dispatchEvent(new CustomEvent('storeFilterChange', {
        detail: { filteredStores: matchingStores }
      }));

      // Open popup for first result if only one match
      if (matchingStores.length === 1 && highlightedMarkers[0]) {
        highlightedMarkers[0].marker.openPopup();
      }
    } else {
      console.log('No stores found for:', query);

      // Notify directory to show empty results
      window.dispatchEvent(new CustomEvent('storeFilterChange', {
        detail: { filteredStores: [] }
      }));

      // Try geocoding as fallback for generic location searches
      const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery.trim())}&limit=1`;

      fetch(geocodeUrl, {
        headers: {
          'User-Agent': 'ShopifyStoreMap/1.0'
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lng = parseFloat(data[0].lon);
          map.setView([lat, lng], 10);
        }
      })
      .catch(error => {
        console.error('Geocoding error:', error);
      });
    }
  }

  if (searchInput) {
    // Real-time search as user types (with debounce)
    searchInput.addEventListener("input", function (e) {
      const searchQuery = this.value;

      // Clear previous timeout
      clearTimeout(searchTimeout);

      // If search is cleared or too short, reset everything immediately
      if (searchQuery.trim().length === 0 || searchQuery.trim().length < 3) {
        // Reset highlighted markers to default color
        highlightedMarkers.forEach(m => {
          if (map.hasLayer(m.marker)) {
            m.marker.setIcon(new L.Icon.Default());
          }
        });
        highlightedMarkers = [];

        // Remove search marker if exists
        if (searchMarker) {
          map.removeLayer(searchMarker);
          searchMarker = null;
        }

        // Reset map view and directory to show all stores
        if (storeLocations.length > 0) {
          // Only fit bounds if input is completely empty
          if (searchQuery.trim().length === 0) {
            const bounds = L.latLngBounds(storeLocations.map(s => [s.lat, s.lng]));
            map.fitBounds(bounds, { padding: [50, 50], maxZoom: 12 });
            console.log('Search cleared - showing all', storeLocations.length, 'stores');
          }

          // Always notify directory to show all stores when input is empty or too short
          window.dispatchEvent(new CustomEvent('storeFilterChange', {
            detail: { filteredStores: storeLocations }
          }));
        }

        // Don't continue search if too short
        return;
      }

      // Wait 800ms after user stops typing before searching
      searchTimeout = setTimeout(() => {
        if (searchQuery.trim().length >= 3) {
          searchAndMarkLocation(searchQuery);
        }
      }, 800);
    });

    // Also allow Enter key for immediate search
    searchInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter" || e.keyCode === 13) {
        e.preventDefault();
        clearTimeout(searchTimeout);

        const searchQuery = this.value.trim();
        console.log('Enter key pressed with query:', searchQuery);

        if (searchQuery.length >= 3) {
          // Valid search query, execute search
          searchAndMarkLocation(this.value);
        } else if (searchQuery.length === 0) {
          // Empty input, reset to show all stores
          highlightedMarkers.forEach(m => {
            if (map.hasLayer(m.marker)) {
              m.marker.setIcon(new L.Icon.Default());
            }
          });
          highlightedMarkers = [];

          if (storeLocations.length > 0) {
            const bounds = L.latLngBounds(storeLocations.map(s => [s.lat, s.lng]));
            map.fitBounds(bounds, { padding: [50, 50], maxZoom: 12 });

            window.dispatchEvent(new CustomEvent('storeFilterChange', {
              detail: { filteredStores: storeLocations }
            }));
          }
        }
        // If 1-2 characters, do nothing (too short to search)
      }
    });
  }

  // Around Me button - Get user location and find nearest stores
  let userLocationMarker = null;

  if (aroundMeButton) {
    aroundMeButton.addEventListener("click", function () {
      // Disable button (don't change text or SVG)
      aroundMeButton.disabled = true;
      aroundMeButton.style.opacity = '0.6';
      aroundMeButton.style.cursor = 'not-allowed';

      // Function to re-enable button
      const reEnableButton = () => {
        if (aroundMeButton) {
          aroundMeButton.disabled = false;
          aroundMeButton.style.opacity = '1';
          aroundMeButton.style.cursor = 'pointer';
          console.log('Button re-enabled');
        }
      };

      if (navigator.geolocation) {
        // Use high accuracy and timeout options
        const geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0 // Don't use cached position
        };

        navigator.geolocation.getCurrentPosition(
          function (position) {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            // Validate coordinates are valid
            if (isNaN(userLat) || isNaN(userLng) || !isFinite(userLat) || !isFinite(userLng)) {
              alert("Coordonnées de localisation invalides. Veuillez réessayer.");
              console.error('Invalid coordinates:', userLat, userLng);
              return;
            }

            console.log('User location detected:', userLat, userLng, 'Accuracy:', position.coords.accuracy, 'meters');

            // Remove previous user location marker if exists
            if (userLocationMarker) {
              map.removeLayer(userLocationMarker);
            }

            // Add marker for user location (disable autoPan to prevent map movement)
            userLocationMarker = L.marker([userLat, userLng], {
              icon: L.divIcon({
                className: 'user-location-marker',
                html: '<div style="background-color: #00664F; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 0 2px #00664F;"></div>',
                iconSize: [20, 20],
                iconAnchor: [10, 10]
              })
            })
              .addTo(map)
              .bindPopup("Votre position", { autoPan: false });

            // Calculate distances to all store locations
            const locationsWithDistances = locationMarkers.map(loc => {
              const distance = calculateDistance(userLat, userLng, loc.lat, loc.lng);
              return {
                ...loc,
                distance: distance
              };
            });

            // Sort by distance (nearest first)
            locationsWithDistances.sort((a, b) => a.distance - b.distance);

            // Get nearest stores (top 10)
            const nearestStores = locationsWithDistances.slice(0, 10);

            if (nearestStores.length > 0) {
              console.log('Found', nearestStores.length, 'nearest stores');

              // Clear any previous search highlights
              highlightedMarkers.forEach(m => {
                if (map.hasLayer(m.marker)) {
                  m.marker.setIcon(new L.Icon.Default());
                }
              });
              highlightedMarkers = [];

              // Highlight nearest stores
              nearestStores.forEach(store => {
                const redIcon = new L.Icon({
                  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
                  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                  iconSize: [25, 41],
                  iconAnchor: [12, 41],
                  popupAnchor: [1, -34],
                  shadowSize: [41, 41]
                });
                store.marker.setIcon(redIcon);
                highlightedMarkers.push(store);

                console.log('-', store.name, ':', store.distance.toFixed(1), 'km');
              });

              // Get the nearest store (first one)
              const nearestStore = nearestStores[0];

              console.log('Nearest store:', nearestStore.name, 'at', nearestStore.distance.toFixed(1), 'km');

              // Fit map to show user location and nearest stores
              const boundsPoints = [[userLat, userLng]].concat(nearestStores.map(s => [s.lat, s.lng]));
              const bounds = L.latLngBounds(boundsPoints);
              map.fitBounds(bounds, { padding: [100, 100], maxZoom: 13 });

              // Create popup content with nearest stores
              let popupContent = '<div style="max-width: 250px;"><strong>Magasins les plus proches:</strong><br><br>';
              nearestStores.forEach((store, index) => {
                const distanceKm = store.distance.toFixed(1);
                const storeName = store.location ? (store.location.name || store.name) : store.name;
                popupContent += `${index + 1}. ${storeName} - <strong>${distanceKm} km</strong><br>`;
              });
              popupContent += '</div>';

              // Update user location popup with nearest stores
              if (userLocationMarker && map.hasLayer(userLocationMarker)) {
                userLocationMarker.setPopupContent(popupContent);
                userLocationMarker.openPopup();
              }

              // Update store popups with distance information
              nearestStores.forEach((store) => {
                const distanceKm = store.distance.toFixed(1);
                if (store.marker && map.hasLayer(store.marker) && store.location) {
                  // Recreate full popup with distance
                  let storePopupContent = `<div style="min-width: 200px;">
                    <strong style="font-size: 14px; color: #1A1A1A;">${store.location.name}</strong>
                    <div style="color: #00664F; font-weight: 600; margin-top: 8px;">📍 ${distanceKm} km</div>`;

                  if (store.location.address1) {
                    storePopupContent += `<br><span style="font-size: 13px; color: #6A7282;">${store.location.address1}</span>`;
                  }
                  if (store.location.address2) {
                    storePopupContent += `<br><span style="font-size: 13px; color: #6A7282;">${store.location.address2}</span>`;
                  }
                  if (store.location.postalCode || store.location.city) {
                    storePopupContent += `<br><span style="font-size: 13px; color: #6A7282;">${store.location.postalCode} ${store.location.city}</span>`;
                  }
                  if (store.location.phone) {
                    storePopupContent += `<br><a href="tel:${store.location.phone}" style="font-size: 13px; color: #00664F; text-decoration: none;">📞 ${store.location.phone}</a>`;
                  }
                  storePopupContent += `</div>`;

                  store.marker.setPopupContent(storePopupContent);
                }
              });

              // Re-enable button
              reEnableButton();
            } else {
              alert("Aucun magasin trouvé à proximité.");
              // Re-enable button if no stores found
              reEnableButton();
            }
          },
          function (error) {
            // Re-enable button on error
            reEnableButton();

            let errorMessage = "Impossible d'obtenir votre position. ";
            switch(error.code) {
              case error.PERMISSION_DENIED:
                errorMessage += "Permission refusée. Veuillez autoriser l'accès à votre localisation.";
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage += "Position indisponible.";
                break;
              case error.TIMEOUT:
                errorMessage += "Délai d'attente dépassé. Veuillez réessayer.";
                break;
              default:
                errorMessage += "Erreur inconnue.";
                break;
            }
            console.error('Geolocation error:', error);
            alert(errorMessage);
          },
          geoOptions
        );
      } else {
        // Re-enable button if geolocation not supported
        reEnableButton();
        alert(
          "La géolocalisation n'est pas supportée par votre navigateur."
        );
      }
    });
  }
})();
